import * as React from "react"
import Svg, {Path} from "react-native-svg"

function MoonSvg({width = 18, height = 18, fill = "#3CA6F5", ...props}) {
    return (
        <Svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <Path
                d="M21 13.35A9 9 0 1110.65 3a7 7 0 0010.35 10.35z"
                fill={fill}
            />
        </Svg>
    )
}

export default MoonSvg